/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitInvestmentEntitySelection} from '../api'

export const useMutationSubmitInvestmentEntitySelection = createReactQueryMutationHook('submitInvestmentEntitySelection', submitInvestmentEntitySelection)
